// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
function vwToPx(widthString) {
    if (widthString.endsWith("px")) {
        return Number(widthString.replace("px", ""));
    }
    else if (widthString.endsWith("vw")) {
        const viewportWidth = window.innerWidth;
        const pixels = (Number(widthString.replace("vw", "")) / 100) * viewportWidth;
        return pixels;
    }
    else {
        console.error("Invalid width string. Only px and vw are supported.");
        return 0;
    }
}
export default vwToPx;
